async function request(method, url, body) {
  const res = await fetch(url, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export const api = {
  config: () => request('GET', '/api/config'),
  me: () => request('GET', '/api/me'),
  logout: () => request('POST', '/api/logout'),
  register: (username, password) => request('POST', '/api/auth/register', { username, password }),
  login: (username, password) => request('POST', '/api/auth/login', { username, password }),
  updateProfile: (payload) => request('PATCH', '/api/profile', payload),

  actor: (username) => request('GET', `/api/actors/${encodeURIComponent(username)}`),
  nearbyActors: (bbox) => request('GET', `/api/actors/nearby?bbox=${encodeURIComponent(bbox)}`),
  createPost: (payload) => request('POST', '/api/posts', payload),
  editPost: (id, payload) => request('PATCH', `/api/posts/${id}`, payload),
  confirmPost: (id) => request('PATCH', `/api/posts/${id}`, { confirm: true }),
  closePost: (id) => request('PATCH', `/api/posts/${id}`, { close: true }),
  reopenPost: (id) => request('PATCH', `/api/posts/${id}`, { reopen: true }),
  setPostLive: (id, live) => request('PATCH', `/api/posts/${id}`, { live }),
  reportPost: (id, reason = '') => request('POST', `/api/posts/${id}/report`, { reason }),
  deletePost: (id) => request('DELETE', `/api/posts/${id}`),
  createDoing: (payload) => request('POST', '/api/doings', payload),
  clearDoing: () => request('DELETE', '/api/doings/current'),
  respondCompanion: (id, accept) => request('PATCH', `/api/doings/${id}/companions/me`, { accept }),
  links: () => request('GET', '/api/links'),
  addLink: (url) => request('POST', '/api/links', { url }),
  removeLink: (id) => request('DELETE', `/api/links/${encodeURIComponent(id)}`),
  orderLinks: (ids) => request('PATCH', '/api/links', { ids }),
  blockActor: (id) => request('POST', `/api/blocks/${encodeURIComponent(id)}`),
  unblockActor: (id) => request('DELETE', `/api/blocks/${encodeURIComponent(id)}`),
};
